import React from 'react';
import './ProductCard.css';
import { useTranslation } from 'react-i18next';

function ProductCard({ image, alt, title, descriptionKey }) {
  const { t } = useTranslation('products');

  return (
    <div className="ProductCard">
      <div className="ProductCard_img_box">
        <img src={image} alt={alt} />
      </div>
      <div className="Products_section2_items_box">
        <div className="Products_section2_items_title">{title}</div>
        <div className="Products_section2_items_description">{t(descriptionKey)}</div>
      </div>
    </div>
  );
}

export default ProductCard;
